export default __webpack_public_path__ + "static/media/desktop2.beb42167.png";